import { useSelector } from 'react-redux';

import { CONNECTION_QUALITY, CONNECTION_STATUS } from '../constants';
import { selectConnectionQuality, selectConnectionStatus } from '../state/selectors';

export const useConnectivity = () => {
    const status = useSelector(selectConnectionStatus);
    const quality = useSelector(selectConnectionQuality);

    return {
        status,
        isOffline:
            status === CONNECTION_STATUS.OFFLINE || status === CONNECTION_STATUS.RECONNECTING,
        isSlow: quality === CONNECTION_QUALITY.SLOW,
    };
};
